module.exports = __webpack_public_path__ + "static/media/header-desktop.a144eb8b.jpg";